import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { UPDATE_TASK } from "../task.queries";
import { TaskStatus } from "../../../__generated__/globalTypes";
import {
  UpdateTaskMutation,
  UpdateTaskMutationVariables,
} from "../../../__generated__/UpdateTaskMutation";

export const useToggleTask = () => {
  const [mutate, { loading }] = useMutation<
    UpdateTaskMutation,
    UpdateTaskMutationVariables
  >(UPDATE_TASK, {
    refetchQueries: "active",
  });

  const toggle = async (id: number, currentStatus: TaskStatus) => {
    try {
      const nextStatus =
        currentStatus === TaskStatus.Done ? TaskStatus.Todo : TaskStatus.Done;
      const { data } = await mutate({
        variables: { id, input: { status: nextStatus } },
      });
      if (!data?.updateTask?.ok) {
        throw Error(data?.updateTask?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return { toggle, loading };
};
